import * as types from '../mutation-types'
// this is comment
const state = {
  accessToken: null,
  login: false,
  name: '',
  email: '',
  campaignDetail: null,
  companyName: '',
  userCountry: '',
  userType: '',
  maxVenueLimit: 5,
  checkIn: {name: '', email: '', phone: ''},
  testAccount: false,
  admin: true,
  enableMarketing: false,
  enablePurchase: false,
  rootAdmin: true,
  adBlock: false,
  resellerId: '0',
  id: '',
  menu: true
}

const mutations = {
  [types.CHANGE_LOGIN] (state, value) {
    state.login = value
  },

  [types.CHANGE_MENU] (state, value) {
    state.menu = value
  },

  [types.CHANGE_CAMPAIGN] (state, value) {
    state.campaignDetail = value
  },

  [types.LOGOUT] (state) {
    state.login = false
    state.accessToken = null
    state.maxVenueLimit = 5
  },

  [types.SAVE_CHECKIN_INFO] (state, value) {
    if (value.name) {
      state.checkIn.name = value.name
    }

    if (value.email) {
      state.checkIn.email = value.email
    }

    if (value.phone) {
      state.checkIn.phone = value.phone
    }
  },

  [types.LOGIN] (state, value) {
    state.login = true
    if (value.data) {
      state.accessToken = value.data
    }

    if (value.user && value.user.name) {
      state.name = value.user.name
    }

    if (value.user) {
      if (value.user.reseller_id) {
        state.resellerId = String(value.user.reseller_id)
      } else state.resellerId = '0'

      if (value.user.id) {
        state.id = value.user.id
      } else {
        state.id = ''
      }
    }

    if (value.company_name) {
      state.companyName = value.company_name
    }

    if (value.user_country) {
      state.userCountry = value.user_country
    }

    if (typeof value.enable_marketing !== 'undefined') {
      if (value.enable_marketing === '1' || value.enable_marketing === true) {
        state.enableMarketing = true
      } else state.enableMarketing = false
    }

    if (typeof value.enable_purchase !== 'undefined') {
      state.enablePurchase = value.enable_purchase
    }

    if (value.reseller_id) {
      state.resellerId = value.reseller_id
    }

    if (value.email) {
      state.email = value.email
    }

    if (value.user_type || value.user_type === '') {
      state.userType = value.user_type
      if (state.userType === '' || state.userType === 'super_admin') {
        state.rootAdmin = true
        state.admin = true
      } else if (state.userType === 'admin') {
        state.rootAdmin = false
        state.admin = true
      } else {
        state.rootAdmin = false
        state.admin = false
      }
    }

    if (value.test_account) {
      state.testAccount = value.test_account
    }

    if (value.max_venue_limit) {
      state.maxVenueLimit = parseInt(value.max_venue_limit)
    }
  },

  [types.CHANGE_ADBLOCK] (state, value) {
    if (value.adBlock) {
      if (value.adBlock === '1') {
        state.adBlock = true
      } else {
        state.adBlock = false
      }
    }
  }
}
const actions = {}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/common.js